module.exports = __webpack_public_path__ + "img/leeb-logo.6b1b4fe6.svg";